import React from 'react';

import SettingsTab from './SettingsTab';

function UserSettings() {
  return <SettingsTab />;
}

export default UserSettings;
